<template>
	<div style="display:block;width:100%;height:calc(100vh - 100px);gap:20px;box-sizing:border-box;padding:20px 0;">
		<!-- 左侧：上传 + 控制按钮 + 日志列表 -->
		<div style="width:100%;height:10%;">
			<!-- 上传区域 -->
			<div style="display: flex;background:#fff;padding:16px;border-radius:6px;border:1px solid #eee;">
				<h4 style="margin:0 0 10px 0;">上传原始HTML</h4>
				<input type="file" accept=".html" @change="handleUploadHtml" />
				<div style="margin-top:8px;display:flex;gap:8px;">
					<!-- <button @click="downloadHtmlFile">下载处理后HTML</button> -->
					<!-- <button @click="uploadHtmlFile">上传HTML文件</button> -->
				</div>
			</div>
		</div>
		<div style="width: 100%;">
			<HtmlPlayView :iframeUrlOrigin="iframeUrlOrigin" :iframeUrlPlay="iframeUrlPlay" />
		</div>
	</div>
</template>

<script>
	import {
		HtmlToOss,
		injectCubePostMessage
	} from '../../js/img.js';
	import HtmlPlayView from './html/HtmlIframeView.vue'
	export default {
		name: "HtmlInjectPlaybackWrapper",
		components: {
			HtmlPlayView
		},
		props: {
			value: {
				type: Object,
				default: () => ({})
			},
			vimSave: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				rawHtml: "",
				processedHtml: "",
				iframeUrlOrigin: "", // 注入干净基线，仅回放初始化加载一次
				iframeUrlPlay: "", // 手动操作页面
				cachePlaySnapshot: "", // 回放前缓存用户操作页面快照
				currentIframeSrc: "",
				showContinueOperateBtn: false,
				isPlayMode: false, // true=回放模式 屏蔽录制上报
				state: {
					recordQueue: [],
					playQueue: [],
					currentPlayIndex: -1,
					isPause: false,
					isPlaying: false,
					iframeReady: false,
					logIndex: 0
				},
				uploadFileName: '',
				login: null,
			};
		},
		mounted() {
			window.addEventListener("message", this.onParentMessage);
		},
		beforeDestroy() {
			window.removeEventListener("message", this.onParentMessage);
			if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
			if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
			if (this.cachePlaySnapshot) URL.revokeObjectURL(this.cachePlaySnapshot);
		},
		methods: {


			// 下载示例
			downloadHtmlFile() {
				if (!this.uploadFileName) {
					this.$message.warning("请先上传HTML文件");
					return;
				}
				const file = this.getProcessedHtmlFile();
				const url = URL.createObjectURL(file);
				const a = document.createElement("a");
				a.href = url;
				a.download = file.name;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(url);
			},
			getProcessedHtmlFile() {
				const htmlContent = this.processedHtml;
				// 直接使用上传时的原始文件名
				const file = new File(
					[htmlContent],
					this.uploadFileName, {
						type: "text/html;charset=utf-8",
						lastModified: Date.now()
					}
				);
				console.log('file', file)
				return file;
			},
			// 上传接口模板
			async uploadHtmlFile() {
				if (!this.uploadFileName) {
					this.$message.warning("请先上传HTML文件");
					return;
				}
				this.loginOpen('文件上传中...')
				try {
					const file = this.getProcessedHtmlFile();

					const type = await HtmlToOss(file, '1')
					if (type != '') {
						console.log('上传成功')
					}
				} catch (err) {

				} finally {
					this.noLogin()
				}

			},
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			async handleUploadHtml(e) {
				const file = e.target.files[0];
				if (!file) return;
				//执行加载
				console.log('file', file)
				this.uploadFileName = file.name;
				this.loginOpen('文件处理中...')
				try {
					this.rawHtml = await file.text();
					this.processedHtml = injectCubePostMessage(this.rawHtml);

					if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
					if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
					if (this.cachePlaySnapshot) URL.revokeObjectURL(this.cachePlaySnapshot);

					const blob = new Blob([this.processedHtml], {
						type: "text/html;charset=utf-8"
					});
					this.iframeUrlOrigin = URL.createObjectURL(blob);
					this.iframeUrlPlay = URL.createObjectURL(blob);


				} catch (error) {

				} finally {
					this.noLogin()
				}
			},
		}
	};
</script>
<style>
	.thTable {
		border: 1px solid #ddd;
		padding: 6px 4px;
		position: sticky;
		top: 0;

		background-color: royalblue;
		color: white;
	}

	.thTables {

		width: 60px;

	}
</style>